import { format } from 'date-fns'
import { cs } from 'date-fns/locale'

/** Format a `YYYY-MM-DD` publish date as e.g. "14. června 2026". */
export function formatArticleDate(isoDate: string): string {
  return format(new Date(isoDate), 'd. MMMM yyyy', { locale: cs })
}

const WORDS_PER_MINUTE = 200

/** Rough reading time in minutes, estimated from the Markdown word count. */
export function readingMinutes(markdown: string): number {
  const words = markdown.trim().split(/\s+/).filter(Boolean).length
  return Math.max(1, Math.round(words / WORDS_PER_MINUTE))
}
